<template>
    <v-container fluid>
      <!-- Leases Section -->
      <v-row>
        <v-col cols="12">
          <v-card class="card-section">
            <v-card-title class="card-title">
              <v-icon left>mdi-calendar-clock</v-icon> <!-- Icon for Leases -->
              Leases
            </v-card-title>
            <v-card-text>
              <!-- Progress Bar for Active and Expired Leases -->
              <v-progress-linear
                :value="activeLeasesPercentage"
                color="orange"  
                :buffer-value="100"
                class="progress-bar"
                height="30"
                @click="goToPage('/Lease')" >
                <template v-slot:default>
                  <!-- Details slot displaying active and expired lease counts -->
                  <div class="progress-text">
                    {{ activeLeasesCount }} Active | {{ expiredLeasesCount }} Expired
                  </div>
                </template>
              </v-progress-linear>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { getDocs, collection, getFirestore } from "firebase/firestore";
  const db = getFirestore();
  
  export default {
    data() {
      return {
        leases: [],
      };
    },
    computed: {
      // Compute total leases and counts for active and expired leases
      totalLeases() {
        return this.leases.length;
      },
      activeLeasesCount() {
        return this.leases.filter(lease => lease.isActive).length;
      },
      expiredLeasesCount() {
        return this.leases.filter(lease => !lease.isActive).length;
      },
      activeLeasesPercentage() {
        if (this.totalLeases === 0) return 0;
        const percentage = (this.activeLeasesCount / this.totalLeases) * 100;
        return isNaN(percentage) ? 0 : percentage;
      },
    },
    async created() {
      await this.fetchLeases(); // Fetch leases when the component is created
    },
    methods: {
      async fetchLeases() {
        try {
          const querySnapshot = await getDocs(collection(db, "Leases"));
          const leases = querySnapshot.docs.map(doc => {
            const data = doc.data();
            const endDate = new Date(data.leaseDetails.endDate); // Convert endDate string to Date object
            const currentDate = new Date(); // Get the current date
            const isActive = endDate > currentDate; // Determine if the lease is active
  
            return {
              leaseId: doc.id, // Lease document ID
              isActive: isActive, // Boolean indicating whether the lease is active
              startDate: data.startDate, // Start date of the lease
              endDate: data.leaseDetails.endDate, // End date of the lease
            };
          });
  
          // Sort leases by start date (or leaseId if needed)
          leases.sort((a, b) => {
            if (a.startDate < b.startDate) return -1;
            if (a.startDate > b.startDate) return 1;
            return 0;
          });
  
          // Assign the sorted leases to the component's data property
          this.leases = leases;
          console.log("Fetched leases:", leases); // Log to check fetched data
        } catch (error) {
          console.error("Error fetching leases:", error);
        }
      },
      goToPage(page) {
      this.$router.push(page);
    },
    },
   
  };
  </script>
  
  <style scoped>
  .card-section {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
  }
  
  .card-title {
    font-size: 20px;
    font-weight: bold;
    color: #1e88e5;
  }
  
  .progress-bar {
    margin-bottom: 12px;
  }
  
  .progress-text {
    color: white; /* Ensures the text is visible inside the progress bar */
    text-align: center;
    font-weight: bold;
  }
  
  .data-item {
    margin-top: 8px;
    font-size: 16px;
  }
  </style>
  